export enum ButtonSize {
  Small = "small",
  Medium = "medium",
  Large = "large",
}

export enum ButtonVariant {
  Primary = "primary",
  Secondary = "secondary",
  Positive = "positive",
  Negative = "negative",
  Link = "link",
  Transparent = "transparent",
}
